// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clear-loader {
  background-color: #ffffff;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999999;
  transition: 0.6s;
  margin: 0 auto;
}

.clear-loader .loader-circle {
  width: 150px;
  height: 150px;
  position: relative;
  border-style: solid;
  border-width: 2px;
  border-top-color: #fb3b3c;
  border-bottom-color: transparent;
  border-left-color: transparent;
  border-right-color: transparent;
  z-index: 10;
  border-radius: 50%;
  box-shadow: 0 1px 5px 0 rgba(35, 181, 185, 0.15);
  background-color: #fff;
  animation: loader 2000ms infinite ease;
  transition: 0.6s;
}

.clear-loader .loader-text {
  font-size: 1.2rem;
  position: absolute;
  top: 50%;
  z-index: 200;
  left: 0;
  right: 0;
  margin: 0 auto;
  text-align: center;
  display: inline-block;
  transform: translateY(-50%);
  padding-top: 6px;
  transition: 0.6s;
}

.clear-loader .loader-text div {
  animation: heartBeat 1.3s infinite running;
}

.text-theme {
  color: #db2d26;
}

@keyframes loader {
  0% {
    transform: rotate(0deg);
    transition: 0.6s;
  }
  100% {
    transform: rotate(360deg);
    transition: 0.6s;
  }
}
@keyframes heartBeat {
  0% {
    transform: scale(1);
  }
  14% {
    transform: scale(1.3);
  }
  28% {
    transform: scale(1);
  }
  42% {
    transform: scale(1.3);
  }
  70% {
    transform: scale(1);
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/common/pageLoader.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EAGA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,gCAAA;EACA,8BAAA;EACA,+BAAA;EACA,WAAA;EACA,kBAAA;EAEA,gDAAA;EACA,sBAAA;EAEA,sCAAA;EAGA,gBAAA;AACF;;AAEA;EACE,iBAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;EAGA,2BAAA;EACA,gBAAA;EAGA,gBAAA;AACF;;AAEA;EACE,0CAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE;IAEE,uBAAA;IAGA,gBAAA;EACF;EAEA;IAEE,yBAAA;IAGA,gBAAA;EAAF;AACF;AAIA;EACE;IAEE,mBAAA;EAFF;EAKA;IAEE,qBAAA;EAHF;EAMA;IAEE,mBAAA;EAJF;EAOA;IAEE,qBAAA;EALF;EAQA;IAEE,mBAAA;EANF;AACF","sourcesContent":[".clear-loader {\r\n  background-color: #ffffff;\r\n  width: 100%;\r\n  height: 100%;\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  z-index: 999999;\r\n  -webkit-transition: .6s;\r\n  -o-transition: .6s;\r\n  transition: .6s;\r\n  margin: 0 auto;\r\n}\r\n\r\n.clear-loader .loader-circle {\r\n  width: 150px;\r\n  height: 150px;\r\n  position: relative;\r\n  border-style: solid;\r\n  border-width: 2px;\r\n  border-top-color: #fb3b3c;\r\n  border-bottom-color: transparent;\r\n  border-left-color: transparent;\r\n  border-right-color: transparent;\r\n  z-index: 10;\r\n  border-radius: 50%;\r\n  -webkit-box-shadow: 0 1px 5px 0 rgb(35 181 185 / 15%);\r\n  box-shadow: 0 1px 5px 0 rgb(35 181 185 / 15%);\r\n  background-color: #fff;\r\n  -webkit-animation: loader 2000ms infinite ease;\r\n  animation: loader 2000ms infinite ease;\r\n  -webkit-transition: .6s;\r\n  -o-transition: .6s;\r\n  transition: .6s;\r\n}\r\n\r\n.clear-loader .loader-text {\r\n  font-size: 1.2rem;\r\n  position: absolute;\r\n  top: 50%;\r\n  z-index: 200;\r\n  left: 0;\r\n  right: 0;\r\n  margin: 0 auto;\r\n  text-align: center;\r\n  display: inline-block;\r\n  -webkit-transform: translateY(-50%);\r\n  -ms-transform: translateY(-50%);\r\n  transform: translateY(-50%);\r\n  padding-top: 6px;\r\n  -webkit-transition: .6s;\r\n  -o-transition: .6s;\r\n  transition: .6s;\r\n}\r\n\r\n.clear-loader .loader-text div {\r\n  animation: heartBeat 1.3s infinite running;\r\n}\r\n\r\n.text-theme {\r\n  color: #db2d26;\r\n}\r\n\r\n@keyframes loader {\r\n  0% {\r\n    -webkit-transform: rotate(0deg);\r\n    transform: rotate(0deg);\r\n    -webkit-transition: .6s;\r\n    -o-transition: .6s;\r\n    transition: .6s\r\n  }\r\n\r\n  100% {\r\n    -webkit-transform: rotate(360deg);\r\n    transform: rotate(360deg);\r\n    -webkit-transition: .6s;\r\n    -o-transition: .6s;\r\n    transition: .6s\r\n  }\r\n\r\n}\r\n\r\n@keyframes heartBeat {\r\n  0% {\r\n    -webkit-transform: scale(1);\r\n    transform: scale(1);\r\n  }\r\n\r\n  14% {\r\n    -webkit-transform: scale(1.3);\r\n    transform: scale(1.3);\r\n  }\r\n\r\n  28% {\r\n    -webkit-transform: scale(1);\r\n    transform: scale(1);\r\n  }\r\n\r\n  42% {\r\n    -webkit-transform: scale(1.3);\r\n    transform: scale(1.3);\r\n  }\r\n\r\n  70% {\r\n    -webkit-transform: scale(1);\r\n    transform: scale(1);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
